import { z } from 'zod';

export const CONTENT_SCHEMA_VERSION = 1 as const;

export const CONTENT_ROOTS = {
  project: 'content/projects',
  writing: 'content/writing',
} as const;

export const WRITING_CATEGORIES = ['engineering', 'life', 'tech'] as const;

export type WritingCategory = (typeof WRITING_CATEGORIES)[number];

export const STATIC_INTERNAL_ROUTES = [
  '/',
  '/about',
  '/services',
  '/projects',
  '/blog',
  '/contact',
  '/personal-stuff',
  '/attribution',
] as const;

export const ALLOWED_MDX_COMPONENTS = {
  Callout: z.object({
    tone: z.enum(['info', 'warning', 'success']).optional(),
    title: z.string().min(1).optional(),
  }),
  Figure: z.object({
    src: z.string().min(1),
    alt: z.string().min(1),
    caption: z.string().optional(),
    credit: z.string().optional(),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
  }),
  CodeBlock: z.object({
    language: z.string().min(1).optional(),
    title: z.string().optional(),
  }),
  VideoEmbed: z.object({
    src: z.string().url(),
    poster: z.string().min(1),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    autoplay: z.boolean().optional(),
  }),
  ProjectFacts: z.object({
    items: z.array(z.string().min(1)).min(1),
  }),
} as const;

export type AllowedMdxComponent = keyof typeof ALLOWED_MDX_COMPONENTS;

export function isAllowedMdxComponent(
  name: string
): name is AllowedMdxComponent {
  return name in ALLOWED_MDX_COMPONENTS;
}

export function validateComponentProps(
  name: AllowedMdxComponent,
  props: Record<string, unknown>
) {
  return ALLOWED_MDX_COMPONENTS[name].safeParse(props);
}
